import React, { useState,useEffect } from 'react';
import axios from './axios';
import './Row.css';
import YouTube from "react-youtube";
import movieTrailer from "movie-trailer";

const base_url = "https://image.tmdb.org/t/p/original/";

function Row({ title, fetchUrl, isLargeRow }) { 
     
         //here, ({ title }) means that 'title' is used as a prop
         
         const [movies, setMovies] = useState([]); // state is basically a way to write variables. Also, it can be called a short term memory.
         const [trailerUrl, setTrailerUrl] = useState("");
         //A snippet of code which runs on a specific condition/variable. what we are trying to acheive is when the Row component loads, we are trying to send a request to tmdb for the informatin.
       
    useEffect(() => {
             //if [], run once when the row loads, and don't run it again 
             //if [movies], run everytime the 'movies' changes
             async function fetchData(){                // async bc we are sending request to a third party service(axios)
             const request = await axios.get(fetchUrl);            // await means wait for the answer to come back, when you make a request, even if it takes 5 seconds
             setMovies(request.data.results);                 //we did console log before this step and saw that movies are inside the results in data.
             return request;
             }
             fetchData();

         }, [fetchUrl]);     //if there is any variable which is used inside the userEffect, we hafta hafta hafta include it here '[]' in this line. The reason is that, it's "[fetchUrl]" is dependent on the variable and every time it changes we hafta update our userEffect.            
// fetchUrl is outside the block. so, we need to tell userEffect that you are using fetchUrl from outside the block. That way, userEffect knows if something changes, i need to reapply the code.

const opts = {
    height: '390',
    width: '100%',
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 1,
    },
    };
    
    const handleClick = (movie) => {
        if (trailerUrl) {
            setTrailerUrl("");  //this will basically empty out if the movie is playing already
        } else {
            movieTrailer(movie?.name || "")
                .then((url) => {
                    const urlPramas = new URLSearchParams(new URL(url).search);
                    setTrailerUrl(urlPramas.get('v'));
                
                })
                .catch((error) => console.log(error));
        }
    };


    return (
        
        <div className="row">
            <h2>{title}</h2>
           
            <div className="row__posters">
                {/*above div works kind of as a container after className being added. Container is needed so that rows can be scrolled easily*/}
                {/* several row poster(s)*/}
                {/* key={movie.id} is unique info for each picture. If anything changes in that row, react simply just doesn't re-render the entire row but where its needed*/}
                {/* if we used isLargeRow then use poster_path, otherwise use backdrop_path. That;s why except Netflix Originals, all the icoms are different(they are from backdrop_path*/}
                {/*everything get the row__poster class but if it's a LARGEROW, then we will give it an addition sort of class called "row__posterLarge"*/}
                {movies.map((movie) => (
                    <img
                        key={movie.id}
                        onClick={() => handleClick(movie)}
                        className={`row__poster ${isLargeRow && "row__posterLarge"}`}
                        src={`${base_url}${isLargeRow ? movie.poster_path : movie.backdrop_path}`}
                        alt={movie.name} />
                ))}
            </div>
            {trailerUrl && <YouTube videoId={trailerUrl} opts={opts} />} 
        </div>
    );
}
//Trailer Url in front of the youtube is used, so that we can play video only if we have the url and not show error when we don't
export default Row;
